module.exports = __webpack_public_path__ + "media/images/rectangle-14@1x-10b05f9b33cede9bc5c0eb2f14910dd1.png";